import { render, staticRenderFns } from "./CoverSummaryReview.vue?vue&type=template&id=c033fa9c&scoped=true"
import script from "./CoverSummaryReview.vue?vue&type=script&lang=js"
export * from "./CoverSummaryReview.vue?vue&type=script&lang=js"
import style0 from "./CoverSummaryReview.vue?vue&type=style&index=0&id=c033fa9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c033fa9c",
  null
  
)

export default component.exports